module.exports = __webpack_public_path__ + "img/tail-spin.33ae1e4b.svg";